import { render, staticRenderFns } from "./regionAnjiCompare.vue?vue&type=template&id=446366a1"
import script from "./regionAnjiCompare.vue?vue&type=script&lang=js"
export * from "./regionAnjiCompare.vue?vue&type=script&lang=js"
import style0 from "./regionAnjiCompare.vue?vue&type=style&index=0&id=446366a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports